import React from "react";
import PropTypes from "prop-types";
import { Button, Icon } from "semantic-ui-react";
import { withModal, withPopup } from "../hoc";
import { ProjectDeleteForm } from "../forms";

const ButtonWithModalAndPopup = withModal(ProjectDeleteForm, withPopup(Button));

const ProjectDeleteButton = ({ projectId }) => {
  return (
    <ButtonWithModalAndPopup
      projectId={projectId}
      triggerProps={{
        size: "tiny",
        icon: true,
        content: <Icon name="remove circle" color="red" />,
        popupProps: { size: "mini", content: "Delete", inverted: true },
      }}
      modalProps={{ size: "small" }}
    />
  );
};

ProjectDeleteButton.propTypes = {
  projectId: PropTypes.string.isRequired,
};

export default ProjectDeleteButton;
